import { RegisterOrder } from '@/api/endpoints/Broker/BrokerRequest';
import { Links } from '@/utils/paymentLinks';
import React, { useState } from 'react'

export const usePayment = () => {
    const [paymentLoading, setPaymentLoading] = useState(false);

    const handlePay = (orderId: number, redirectToId: string | number, amount: number) => {

        setPaymentLoading(true)

        const data = {
            orderId: orderId,
            orderAmount: Number(amount.toFixed(2)),
            // redirectToPage: Links.Medical.redirect(String(redirectToId)),
            redirectToPage: `${window.WEB_LINK}medical-request/${redirectToId}`,
        }

        RegisterOrder(data).then((res) => {

            const redirectUrl = res.formUrl
            window.location.href = redirectUrl

        }).catch((err) => {
            console.log(err)
            setPaymentLoading(false)
        })

    }

    return { paymentLoading, handlePay  ,setPaymentLoading}
}